<template>
  <b-container class="card-container">
    <b-card>
      <b-input-group style='max-width: 500px'>
        <b-form-input placeholder='http://example.com' type='url' v-model='website_url'></b-form-input>
        <b-input-group-append is-text>
          Force&nbsp;
          <b-form-checkbox v-model='force'></b-form-checkbox>
        </b-input-group-append>
        <b-input-group-append>
          <LoadingButton @click="search" :loading="loading" variant='primary'>Record</LoadingButton>
        </b-input-group-append>
      </b-input-group>
    </b-card>

    <b-card header="Result" v-if="src !== undefined">
      <video v-if="src" :src="src" controls width="600"/>
      <b-alert variant='danger' :show="true" v-if="error">{{error.message}}</b-alert>
    </b-card>
  </b-container>
</template>

<script>

import { db, config } from '@/main.js'
import api from '@/lib/api.js'

export default {
  metaInfo: {title: 'Search'},
  data() {
    return {
      loading: false,
      website_url: '',
      force: false,
      src: undefined,
      error: undefined
    }
  },
  methods: {
    async search() {
      this.error = undefined
      this.src = undefined

      this.loading = true
      let results = await api.record_website(this.website_url, this.force)
      this.loading = false

      if (results.error) {
        this.error = results
        this.src = null
      } else {
        this.src = results.url
      }

      console.log(results)
    }
  },
}
</script>

<style scoped>

</style>
